import React, { useState } from 'react';
import Background from './components/layout/Background';
import Navigation from './components/layout/Navigation';
import ExpensesPage from './pages/ExpensesPage';
import KPIPage from './pages/KPIPage';

type Page = 'expenses' | 'kpi';

const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<Page>('expenses');

  const renderPage = () => {
    switch (currentPage) {
      case 'expenses':
        return <ExpensesPage />;
      case 'kpi':
        return <KPIPage />;
      default:
        return <ExpensesPage />;
    }
  };

  return (
    <div className="relative min-h-screen">
      <Background />
      <div className="relative z-10">
        {renderPage()}
        <Navigation currentPage={currentPage} onPageChange={setCurrentPage} />
      </div>
    </div>
  );
};

export default App;
